import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=29da820c&scoped=true"
var script = {}
import style0 from "./ProductView.vue?vue&type=style&index=0&id=29da820c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29da820c",
  null
  
)

export default component.exports